import Vue from 'vue';

Vue.filter('globalIfNull', function(value) {
    if (value == null || value == undefined || value == '') {
        return '暂无';
    } else {
        return value;
    }
})

// Vue.filter('htmlChangeToStr', function(value) {
//     let reg = />(.+)</;
//     return reg.exec(value)[1];
// })